import { useState, useEffect } from 'react';
import { Table, Button, Form, Modal, Tag, Input, Select, App, Image } from 'antd';
import { CloseCircleOutlined, EditOutlined, } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { fetchDepositHistory, verifyDeposit } from '../../store/slices/depositSlice';
import ExportButton from '../../Reusable/ExportButton/ExportButton';
import Loadingpage from '../Loadingpage/Loadingpage';


const DepositHistory = () => {
    const { modal, message } = App.useApp();
    const dispatch = useDispatch();
    const { depositHistory, historyTotal, loading } = useSelector((state) => state.deposit);
    const [page, setPage] = useState({ current: 1, pageSize: 10 });
    const [filters, setFilters] = useState({ status: 'all', type: 'all', search: '' });
    const [isVerifyModalOpen, setIsVerifyModalOpen] = useState(false);
    const [selectedDeposit, setSelectedDeposit] = useState(null);
    const [form] = Form.useForm();
    const verifyStatus = Form.useWatch('status', form);
    const [tableLoading, setTableLoading] = useState(false);
    const [searchTrigger, setSearchTrigger] = useState("");
    useEffect(() => {
        const fetchData = async () => {
            setTableLoading(true);

            try {
                await dispatch(fetchDepositHistory({
                    page: page.current,
                    limit: page.pageSize,
                    status: filters.status,
                    type: filters.type,
                    search: searchTrigger
                }));
            } finally {
                setTableLoading(false);
            }
        };

        fetchData();
    }, [dispatch, page.current, page.pageSize, filters.status, filters.type, searchTrigger]);
    const handleClear = () => {
        setFilters({
            status: 'all',
            type: 'all',
            search: ''
        });

        setSearchTrigger("");

        setPage({
            current: 1,
            pageSize: 10
        });
    };

    const executeVerify = async (values) => {
        try {
            await dispatch(verifyDeposit({
                id: selectedDeposit._id,
                data: {
                    status: values.status,
                    amount: values.approved_amount,
                    remark: values.remark || ""
                }
            })).unwrap();

            message.success('Deposit updated successfully');
            setIsVerifyModalOpen(false);
            dispatch(fetchDepositHistory({ ...filters, page: page.current, limit: page.pageSize }));
        } catch (err) {
            message.error(err.message || 'Failed to update deposit');
        }
    };

    const handleVerify = async (values) => {
        if (values.status === 'approved' && Number(values.approved_amount) > Number(selectedDeposit?.amount)) {
            modal.confirm({
                title: 'Warning',
                content: `The approved amount (${values.approved_amount}) is greater than the requested amount (${selectedDeposit?.amount}). Do you want to proceed?`,
                okText: 'Yes, Proceed',
                cancelText: 'Cancel',
                centered: true,
                onOk: () => executeVerify(values)
            });
        } else if (values.status === "approved" && Number(values.approved_amount) <= 0) {
            message.error('Approved amount must be greater than 0');
        } else {
            executeVerify(values);
        }
    };

    const columns = [
        { title: 'Sno', render: (_, __, i) => <span style={{ color: '#fff' }}>{(page.current - 1) * page.pageSize + i + 1}</span> },
        { title: 'User', dataIndex: ['user_id', 'email'], key: 'user_id.email', render: (t) => <span style={{ color: '#fff' }}>{t}</span> },
        { title: 'Type', dataIndex: 'type', key: 'type', render: (t) => <Tag color={t === 'crypto' ? '#FC4420' : '#108ee9'}>{t?.toUpperCase()}</Tag> },
        { title: 'Amount', dataIndex: 'amount', key: 'amount', render: (val, record) => <span style={{ color: '#fff' }}>{val} {record.currency_id?.name || ''}</span> },
        { title: 'Approved Amount', dataIndex: 'approved_amount', key: 'approved_amount', render: (val, record) => <span style={{ color: '#fff' }}>{val || '-'} {val ? record.currency_id?.name : ''}</span> },
        {
            title: 'Proof / TX Hash',
            dataIndex: 'proof_tx_hash',
            key: 'proof_tx_hash',
            render: (val, record) => record.type === 'fiat' ?
                <Image width={40} style={{ borderRadius: '4px', border: '1px solid #FC4420' }} src={val} />
                : <span style={{ color: '#fff' }}>{val || '-'}</span>
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            render: (status) => (
                <Tag color={status === 'approved' ? 'green' : status === 'pending' ? 'gold' : 'red'}>
                    {status?.toUpperCase()}
                </Tag>
            )
        },
        {
            title: 'Action',
            key: 'action',
            render: (_, record) => (
                <Button
                    type="link"
                    icon={<EditOutlined />}
                    disabled={record.status !== 'pending'}
                    onClick={() => {
                        setSelectedDeposit(record);
                        form.setFieldsValue({ approved_amount: record.amount, status: 'approved' });
                        setIsVerifyModalOpen(true);
                    }}
                    style={{ color: record.status === 'pending' ? '#FC4420' : 'rgba(255, 255, 255, 0.3)' }}
                >
                    Verify
                </Button>
            )
        }
    ];

    return (
        <div className="p-20">
            {/* <Loadingpage /> */}
            <div className="card-clr" style={{ padding: '20px', borderRadius: '16px', border: '1px solid #FC442080' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                    <h2 style={{ color: '#fff', margin: 0 }}>Deposit History</h2>
                </div>
                <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between' }}>
                    <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>

                        <Input.Search
                            placeholder="Search TX Hash"
                            value={filters.search}
                            onChange={(e) => {
                                const value = e.target.value;

                                setFilters((f) => ({
                                    ...f,
                                    search: value,
                                }));

                                // clear icon click
                                if (!value) {
                                    setSearchTrigger("");

                                    setPage({
                                        current: 1,
                                        pageSize: 10,
                                    });
                                }
                            }}
                            onSearch={(v) => {
                                setSearchTrigger(v);

                                setPage({
                                    current: 1,
                                    pageSize: 10,
                                });
                            }}
                            allowClear
                            style={{ width: 250 }}
                            className="input-cls"
                        />
                        <Select
                            defaultValue="all"
                            style={{ width: 140 }}
                            value={filters.status}
                            onChange={(v) => setFilters(f => ({ ...f, status: v }))}
                            className="selected-cls"
                        >
                            <Select.Option value="all">All Status</Select.Option>
                            <Select.Option value="pending">Pending</Select.Option>
                            <Select.Option value="approved">Approved</Select.Option>
                            <Select.Option value="rejected">Rejected</Select.Option>
                        </Select>
                        <Select
                            defaultValue="all"
                            style={{ width: 140 }}
                            value={filters.type}
                            onChange={(v) => setFilters(f => ({ ...f, type: v }))}
                            className="selected-cls"
                        >
                            <Select.Option value="all">All Types</Select.Option>
                            <Select.Option value="crypto">Crypto</Select.Option>
                            <Select.Option value="fiat">Fiat</Select.Option>
                        </Select>
                    </div>
                    <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
                        <Button
                            onClick={handleClear}
                            icon={<CloseCircleOutlined />}
                            loading={loading}
                            disabled={loading}
                        >
                            Clear
                        </Button>
                        <ExportButton
                            category="deposits"
                            filters={{
                                status: filters.status !== 'all' ? filters.status : '',
                                type: filters.type !== 'all' ? filters.type : '',
                                search: filters.search !== '' ? filters.search : '',
                            }}
                        />
                    </div>
                </div>

                <Table
                    columns={columns}
                    dataSource={depositHistory}
                    loading={{
                        spinning: tableLoading,
                        indicator: <Loadingpage isLoading={tableLoading} />,
                    }}
                    pagination={{
                        total: historyTotal,
                        current: page.current,
                        pageSize: page.pageSize,
                        onChange: (p, s) => setPage({ current: p, pageSize: s }),
                        className: "pagination-clr"
                    }}
                    rowKey="_id"
                    className="table-clr"
                    scroll={{ x: 'max-content' }}
                />

                <Modal
                    title="Verify Deposit Request"
                    open={isVerifyModalOpen}
                    onCancel={() => setIsVerifyModalOpen(false)}
                    onOk={() => form.submit()}
                    className="custom-modal"
                    centered
                >
                    <Form form={form} layout="vertical" onFinish={handleVerify}>
                        <p style={{ color: '#fff' }}>User Amount: <b style={{ color: '#FC4420' }}>{selectedDeposit?.amount}</b></p>
                        <Form.Item name="status" label="Status" rules={[{ required: true }]}>
                            <Select>
                                <Select.Option value="approved">Approve</Select.Option>
                                <Select.Option value="rejected">Reject</Select.Option>
                            </Select>
                        </Form.Item>
                        {verifyStatus === 'approved' && (
                            <Form.Item name="approved_amount" label="Approved Amount" rules={[{ required: true }]}>
                                <Input type="number" />
                            </Form.Item>
                        )}
                        <Form.Item name="remark" label="Remark / Reason">
                            <Input.TextArea placeholder="Enter any notes or rejection reason" />
                        </Form.Item>
                    </Form>
                </Modal>
            </div>
        </div>
    );
};

export default DepositHistory;
